import { useRouteError } from 'react-router-dom';
import { ErrorFallback } from './ErrorFallback';

/**
 * Router-level error UI. A data router (createBrowserRouter) catches errors
 * thrown in route elements/loaders itself, before they reach a React error
 * boundary — so route crashes are handled here via `errorElement`.
 */
export function RouteErrorElement() {
  const error = useRouteError();
  // Surface for debugging; wire to a real reporter (e.g. Bugsnag) later.
  console.error('Route error in the Developer Portal:', error);
  return <ErrorFallback />;
}
